import { defineComponent, PropType } from "vue";
import { COMPONENT_NAME } from "./attributes";

export default defineComponent({
  name: COMPONENT_NAME,
  props: {
    pair: {
      type: Object as PropType<{
        currency_id_from: number;
        currency_id_to: number;
        currency_type_from: "fiat" | "crypto";
        currency_type_to: "fiat" | "crypto";
        country_from: string;
        country_to: string;
        buyRate?: number;
        sellRate?: number;
      }>,
      required: true,
    },
    currencyMap: {
      type: Object as PropType<Record<number, string>>,
      required: true,
    },
  },
  computed: {
    displayedPair(): string {
      const fromName = this.currencyMap[this.pair.currency_id_from];
      const toName = this.currencyMap[this.pair.currency_id_to];
      return `${fromName}/${toName}`;
    },

    isUsdUsdtPair(): boolean {
      const fromName = this.currencyMap[this.pair.currency_id_from];
      const toName = this.currencyMap[this.pair.currency_id_to];
      return (
        (fromName === "USD" && toName === "USDT") ||
        (fromName === "USDT" && toName === "USD")
      );
    },

    formattedBuyRate(): string {
      const rate = this.isUsdUsdtPair ? this.pair.sellRate : this.pair.buyRate;
      return rate ? rate.toFixed(2) : "0.00";
    },

    formattedSellRate(): string {
      return this.pair.sellRate ? this.pair.sellRate.toFixed(2) : "0.00";
    },
  },
});
